import ApiService from "@/common/api.service";
import {
  FETCH_NOTES,
  NOTE_UPDATE,
  NOTE_DELETE,
  NOTE_DOWNLOAD
} from "./actions.type";

const actions = {
  [NOTE_UPDATE](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.update("folders/" + params.folder.folder_slug + "/notes/" + params.note.note_slug + "/", params.noteData)
        .then(({ data }) => {
          this.dispatch(FETCH_NOTES, params.folder, { root: true });
          resolve(data);      
        })
    });
  },
  [NOTE_DELETE](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.delete("folders/" + params.folder.folder_slug + "/notes/" + params.note.note_slug + "/")
        .then(() => {
          this.dispatch(FETCH_NOTES, params.folder, { root: true });
          resolve();
        });
    });
  },
  [NOTE_DOWNLOAD](context, noteData) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.getBlob("notes/" + noteData.id + "/download/")
        .then(({ data }) => {
          data.text().then((text) => {
            if(text != 'NO SUBNOTES') {
              resolve(data);
              let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
              let url = window.URL.createObjectURL(blob);
              let hiddenA = document.createElement("a");
              document.body.appendChild(hiddenA);
              hiddenA.style = "display: none";
              hiddenA.href = url;
              hiddenA.download = noteData.title + '.docx';
              hiddenA.click();
              window.URL.revokeObjectURL(url);
            } else {
              resolve('no-subnotes');
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }
}

export default {
  actions
};